import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { adminLogin, TOKEN_KEY } from "@/lib/api";
import Logo from "@/components/site/Logo";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
    const [form, setForm] = useState({ username: "", password: "" });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    if (localStorage.getItem(TOKEN_KEY)) {
        return <Navigate to="/admin" replace />;
    }

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { access_token } = await adminLogin(form.username, form.password);
            localStorage.setItem(TOKEN_KEY, access_token);
            toast.success("Signed in.");
            navigate("/admin");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Invalid credentials");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            data-testid="admin-login-page"
            className="min-h-screen flex items-center justify-center bg-brand-bg px-6"
        >
            <div className="w-full max-w-md bg-brand-surface border border-brand-border p-10">
                <div className="mb-8 flex items-center justify-between">
                    <Logo />
                    <div className="flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-brand-accent font-bold">
                        <Lock size={14} /> Admin
                    </div>
                </div>
                <h1 className="font-serif-editorial text-4xl text-brand-primary leading-tight">
                    Sign in
                </h1>
                <p className="text-sm text-brand-muted mt-2">
                    Restricted to authorised advisers.
                </p>
                <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
                    <div>
                        <label className="text-xs uppercase tracking-[0.18em] text-brand-muted font-bold">
                            Username
                        </label>
                        <input
                            type="text"
                            required
                            value={form.username}
                            onChange={(e) => setForm({ ...form, username: e.target.value })}
                            data-testid="admin-login-username"
                            className="mt-2 w-full bg-transparent border-b border-brand-border py-3 text-lg text-brand-primary focus:border-brand-primary outline-none"
                        />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-[0.18em] text-brand-muted font-bold">
                            Password
                        </label>
                        <input
                            type="password"
                            required
                            value={form.password}
                            onChange={(e) => setForm({ ...form, password: e.target.value })}
                            data-testid="admin-login-password"
                            className="mt-2 w-full bg-transparent border-b border-brand-border py-3 text-lg text-brand-primary focus:border-brand-primary outline-none"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="admin-login-submit"
                        className="w-full bg-brand-primary text-brand-bg px-6 py-4 text-sm font-bold tracking-wide hover:bg-brand-primaryHover transition-colors disabled:opacity-60"
                    >
                        {loading ? "Signing in…" : "Sign in"}
                    </button>
                </form>
            </div>
        </div>
    );
}
